import React from "react";

const Credit = () => {
  return (
    <div className="pt-5 border-t border-white flex justify-between items-center flex-col md:flex-row">
      <p className="text-white">Bungalowfinder - All rights reserved</p>
      <p>
        <a className="text-white" href="https://pixelizio.com/" rel="nofollow">
          Designed and Developed by <b>Pixelizio (Ltd) Pvt</b>
        </a>
      </p>
    </div>
  );
};

export default Credit;
